import { Component, Input } from '@angular/core';

@Component({
    selector: 'ui-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
  @Input('p-message') message: string = '';
  @Input('p-size') size: number;
  @Input('p-primary') primary: boolean = false;
}
